import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';

export function registerAgGrid() {
    ModuleRegistry.registerModules([AllEnterpriseModule]);
}
